const NO_FREEZE_ICON_LANGUAGES = [
  'ar',
  'cs',
  'fi',
  'fr',
  'de',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'pl',
  'pt',
  'th',
  'vi'
]

export const shouldShowFreezeIcon = (language: string): boolean =>
  !NO_FREEZE_ICON_LANGUAGES.includes(language)
